module.exports = __webpack_public_path__ + "static/media/selector_loading.44a0e991.gif";